import { DecimalPipe } from '@angular/common';
import { add, forEach, split, subtract, toNumber } from 'lodash';
import {
  add as fnsAdd,
  format as fnsFormat,
  isValid,
  sub as fnsSub,
} from 'date-fns';

const defaultDateFormat: string = 'dd/MM/yyyy';
const defaultDatePlaceholder: string = 'DD/MM/YYYY';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Args = any[];

export function runPipes(value: string, pipes: string[]): string {
  forEach(pipes, (pipe: string) => {
    const [name, ...args]: string[] = split(pipe, ' : ');

    if (name === 'date') {
      value = datePipe(value, args);
    }

    if (name === 'dateSub') {
      value = dateSubPipe(new Date(value), args);
    }

    if (name === 'dateAdd') {
      value = dateAddPipe(new Date(value), args);
    }

    if (name === 'add') {
      value = add(parseInt(value), parseInt(args[0])).toString();
    }

    if (name === 'subtract') {
      value = subtract(parseInt(value), parseInt(args[0])).toString();
    }

    if (name === 'currency') {
      value = currencyPipe(value, args);
    }

    if (name === 'eval') {
      value = evalPipe(value);
    }

    // keep it always last
    if (name === 'placeholder') {
      value = placeholderPipe(value, args);
    }
  });

  return value;
}

function datePipe(value: number | string | Date, args: Args) {
  const [format = defaultDateFormat, placeholder = defaultDatePlaceholder] =
    args;
  const date: Date = new Date(value);

  return isValid(date) ? fnsFormat(date, format) : placeholder;
}

function dateSubPipe(value: number | Date, args: Args): string {
  const [config, format = defaultDateFormat] = args;

  return fnsFormat(fnsSub(value, JSON.parse(config)), format);
}

function dateAddPipe(value: number | Date, args: Args): string {
  const [config, format = defaultDateFormat] = args;

  return fnsFormat(fnsAdd(value, JSON.parse(config)), format);
}

function currencyPipe(value: string, args: Args): string {
  const [locale, format] = args;

  return isFinite(toNumber(value))
    ? (new DecimalPipe(locale).transform(toNumber(value), format) as string)
    : value;
}

function evalPipe(value: string): string {
  return eval?.(value);
}

function placeholderPipe(value: string, args: Args): string {
  let additionalOptionCondition: boolean;
  const isVariable: boolean = !!value.match(/\{(.*?)\}/);
  const [placeholder, mode] = args;

  switch (mode) {
    case 'ignoreZeros':
      additionalOptionCondition = !value;
      break;

    default:
      additionalOptionCondition = !value || toNumber(value) === 0;
  }

  return isVariable || additionalOptionCondition ? placeholder : value;
}
